import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { useAuth, useRoles } from '../hooks'

interface AdminRouteProps {
  children: ReactNode
}

export const AdminRoute = ({ children }: AdminRouteProps) => {
  const { user, loading } = useAuth()
  const { isAdmin } = useRoles()

  // Show loading while checking auth state
  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-center space-y-4">
          <div className="text-6xl mb-4">🚀</div>
          <p className="text-lg text-default-600">Loading...</p>
        </div>
      </div>
    )
  }

  // Redirect to home if not authenticated
  if (!user) {
    return <Navigate to="/" replace />
  }

  // Redirect to home if not admin
  if (!isAdmin) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
